import { makeStyles, InputBase } from '@material-ui/core';
import { classNames } from '../../utils';

const useStyles = makeStyles((theme) => ({
  input: ({ height, width, fontSize, padding }) => ({
    borderRadius: '10px',
    border: '1px solid #E4E7EB',
    backgroundColor: '#FFF',
    padding,
    height: height ?? '3.5rem',
    width: width ?? 'auto',
    '& .MuiInputBase-input': {
      padding: '0',
      fontFamily: 'NotoSans-Medium',
      color: '#2e4469',
      fontSize: fontSize,
      height: '2rem',
    },
    '&.Mui-disabled': {
      backgroundColor: '#f5f5f5',
    },
  }),
}));

const StyleInput = ({
  value,
  onChange,
  className,
  height = '3.5rem',
  width = 'auto',
  fontSize = '1rem',
  placeholder = 'Input',
  type = 'default',
  padding = '0 1.25rem',
  inputType = 'text',
  ...rest
}) => {
  const classes = useStyles({ height, width, fontSize, padding });

  const handleChange = (event) => {
    if (type === 'number') {
      onChange(event?.target?.value?.replace(/\D/g, ''));
    } else {
      onChange(event.target.value);
    }
  };

  return (
    <InputBase
      className={className ? classNames(className, classes.input) : classes.input}
      value={value}
      onChange={handleChange}
      placeholder={placeholder}
      type={inputType}
      {...rest}
    />
  );
};

export default StyleInput;
